
export enum ScatterAnimTypes {
    IDLE = "idle",
    ANTICIPATION = "anticipation",
    TRIGGER = "trigger"
}